<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">危险源设置</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新建分级</el-button>
        </el-form-item>
      </el-form>
    </div>
    <custom-table :data="tableData" ref="table" border style="width: 100%">
      <custom-table-column fixed label="序号" type="index" width="50">
      </custom-table-column>
      <custom-table-column prop="name" label="危险源名称">
      </custom-table-column>
      <!-- <custom-table-column prop="category" label="分类" width="160">
      </custom-table-column> -->
      <custom-table-column prop="level" label="危险源级别" width="220">
      </custom-table-column>
      <custom-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleRiskManage(scope.row)" type="text" size="small">风险点管理</el-button>
          <el-button @click="handleEditNew(scope.row, ['id'], () => handleEditInit(scope.row))" type="text"
            size="small">编辑</el-button>
          <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
        </template>
      </custom-table-column>
    </custom-table>
    <div class="pageLine">
      <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="危险源名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入危险源名称" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="危险源级别" prop="level_id">
          <el-select v-model="ruleForm.level_id" clearable placeholder="请选择" style="width:552px;"
            @change="onLevelChange">
            <el-option v-for="(item, index) in $store.state.dangerLevels" :key="index" :label="item.level"
              :value="item.id">
              <p>{{ `${item.level}` }}</p>
              <p v-if="item.safety_check" style=" color: #8492a6; font-size: 13px">安全检查：{{ item.safety_check }}</p>
              <p v-if="item.safety_training" style=" color: #8492a6; font-size: 13px">安全培训：{{ item.safety_training }}
              </p>
              <p v-if="item.safety_assessment" style=" color: #8492a6; font-size: 13px">安全评估：{{ item.safety_assessment
              }}
              </p>
              <p v-if="item.safety_guarantee" style=" color: #8492a6; font-size: 13px">安全保障：{{ item.safety_guarantee }}
              </p>
              <p v-if="item.description" style=" color: #8492a6; font-size: 13px">描述：{{ item.description }}</p>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type == 'add'"
            @click="submitFormByFun('ruleForm', createMethod)">确认</el-button>
          <el-button type="primary" v-if="type == 'edit'"
            @click="submitFormByFun('ruleForm', updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 风险点管理 -->
    <el-dialog :close-on-click-modal="false" :title="'风险点管理' + (hazardName ? `：${hazardName}` : '')"
      :visible.sync="riskVisible" width="900px">
      <div>
        <el-form :inline="true" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleRiskAdd">新增风险点</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <custom-table :data="riskTableData" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="name" label="风险点名称" min-width="180">
          </custom-table-column>
          <custom-table-column prop="description" label="风险描述" min-width="320">
          </custom-table-column>
          <custom-table-column prop="measures_list" label="防护措施" min-width="320">
            <template slot-scope="scope">
              <div v-if="scope.row.measures_list && scope.row.measures_list.length > 0">
                <p v-for="(item, index) in scope.row.measures_list" :key="index" style="margin-bottom:4px;">
                  {{ item.content }}
                </p>
              </div>
              <div v-else style="color:#8492a6;">暂无防护措施</div>
            </template>
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="handleMeasuresManage(scope.row)" type="text" size="small">维护措施</el-button>
              <el-button @click="handleRiskEdit(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleRiskDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='riskTotal' ref="riskPage" @getList="getRiskList"></PageLine>
        </div>
      </div>
      <!-- 新增/编辑风险点 -->
      <el-dialog append-to-body :close-on-click-modal="false" :title="riskTitle" :visible.sync="riskFormVisible"
        width="600px">
        <el-form :model="riskRuleForm" :rules="riskRules" ref="riskRuleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="风险点名称" prop="name">
            <el-input v-model="riskRuleForm.name" placeholder="请输入风险点名称" style="width:412px;"></el-input>
          </el-form-item>
          <el-form-item label="风险描述" prop="description">
            <el-input type="textarea" v-model="riskRuleForm.description" :rows="4" placeholder="请输入风险描述"
              style="width:412px;"></el-input>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="riskType == 'add'"
              @click="submitFormByFun('riskRuleForm', createRiskMethod)">确认</el-button>
            <el-button type="primary" v-if="riskType == 'edit'"
              @click="submitFormByFun('riskRuleForm', updateRiskMethod)">编辑</el-button>
            <el-button @click="handleRiskReset" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 风险点删除确认 -->
      <el-dialog append-to-body :close-on-click-modal="false" title="提示" :visible.sync="riskDelVisible" width="400px">
        <span>是否删除该风险点</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="riskDelVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteRiskMethod">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
    <!-- 维护措施(与风险点弹窗同级,避免多层弹窗嵌套导致表格渲染异常) -->
    <el-dialog :close-on-click-modal="false" :title="'维护措施' + (riskName ? `：${riskName}` : '')"
      :visible.sync="measuresVisible"  width="800px">
      <div>
        <el-form :inline="true" class="demo-form-inline" label-position="left">
          <el-form-item>
            <el-button type="primary" @click="handleMeasuresAdd">新增维护措施</el-button>
          </el-form-item>
        </el-form>
      </div> 
      <div>
        <custom-table :data="measuresTableData" border style="width: 100%">
          <custom-table-column fixed label="序号" type="index" width="50">
          </custom-table-column>
          <custom-table-column prop="content" label="措施内容" min-width="300">
          </custom-table-column>
          <custom-table-column prop="order" label="排序" width="100">
          </custom-table-column>
          <custom-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="handleMeasuresEdit(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="handleMeasuresDelet(scope.row.id)" type="text" size="small">删除</el-button>
            </template>
          </custom-table-column>
        </custom-table>
        <div class="pageLine">
          <PageLine :total='measuresTotal' ref="measuresPage" @getList="getMeasuresList"></PageLine>
        </div>
      </div>
      <!-- 新增/编辑维护措施 -->
      <el-dialog append-to-body :close-on-click-modal="false" :title="measuresTitle" :visible.sync="measuresFormVisible"
        width="600px">
        <el-form :model="measuresRuleForm" :rules="measuresRules" ref="measuresRuleForm" label-width="100px"
          class="demo-ruleForm">
          <el-form-item label="措施内容" prop="content">
            <el-input type="textarea" v-model="measuresRuleForm.content" :rows="4" placeholder="请输入措施内容"
              style="width:412px;"></el-input>
          </el-form-item>
          <el-form-item label="排序" prop="order">
            <el-input-number v-model="measuresRuleForm.order" :min="0" :max="9999" controls-position="right"
              style="width:160px;"></el-input-number>
          </el-form-item>
          <el-form-item style="margin-top:8px;width:100%;text-align:right;">
            <el-button type="primary" v-if="measuresType == 'add'"
              @click="submitFormByFun('measuresRuleForm', createMeasuresMethod)">确认</el-button>
            <el-button type="primary" v-if="measuresType == 'edit'"
              @click="submitFormByFun('measuresRuleForm', updateMeasuresMethod)">编辑</el-button>
            <el-button @click="handleMeasuresReset" style="margin-right:24px;">重置</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 措施删除确认 -->
      <el-dialog append-to-body :close-on-click-modal="false" title="提示" :visible.sync="measuresDelVisible"
        width="400px">
        <span>是否删除该维护措施</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="measuresDelVisible = false">取 消</el-button>
          <el-button type="primary" @click="deleteMeasuresMethod">确 定</el-button>
        </span>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinUpload } from '@/assets/js/mixin/upload';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinUpload],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      props: {
        label: 'name',
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      formInline: {
        structure_1: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },

      formInline1: {},
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        name: '',
        // 级别文案 + 级别id(接口字段:level / level_id)
        level: '',
        level_id: '',
      },
      rules: {
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
        level_id: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      uploadType: 'image',
      btnTitle: '点击上传警示图标',
      inputValue: '',
      inputVisible: false,
      safes: [],
      inputValue1: '',
      inputVisible1: false,
      fileFieldName: 'warning_icons',
      // 风险点管理(仅本页使用,直接内联,不做成通用组件)
      riskVisible: false,
      riskTableData: [],
      riskTotal: 0,
      hazardId: '',
      hazardName: '',
      riskFormVisible: false,
      riskDelVisible: false,
      riskDelId: '',
      riskType: '',
      riskTitle: '新增',
      riskRuleForm: {
        hazard_id: '',
        name: '',
        description: '',
      },
      riskRules: {
        name: [{ required: true, message: '请输入风险点名称', trigger: 'blur' }],
        description: [{ required: true, message: '请输入风险描述', trigger: 'blur' }],
      },
      // 风险点下的维护措施(同样内联)
      measuresVisible: false,
      measuresTableData: [],
      measuresTotal: 0,
      riskId: '',
      riskName: '',
      measuresFormVisible: false,
      measuresDelVisible: false,
      measuresDelId: '',
      measuresType: '',
      measuresTitle: '新增',
      measuresRuleForm: {
        risk_id: '',
        content: '',
        order: 10,
      },
      measuresRules: {
        content: [{ required: true, message: '请输入措施内容', trigger: 'blur' }],
        order: [{ required: true, message: '请输入排序', trigger: 'blur' }],
      },
    };
  },
  created() { },
  mounted() {
    // this.getList();
    // this.$store.dispatch('getDangerCategorys');
    this.$store.dispatch('getDangerLevels');
  },
  watch: {
  },
  methods: {
    // 编辑回填:级别文案(列表未返回 level 时按 level_id 从字典匹配)
    handleEditInit(row) {
      if (!this.ruleForm.level) {
        this.ruleForm.level = this.getLevelName(row.level_id)
      }
    },
    // 选择级别时同步级别文案(接口字段 level)
    onLevelChange(levelId) {
      this.ruleForm.level = this.getLevelName(levelId)
    },
    // 按级别id取级别文案
    getLevelName(levelId) {
      const list = (this.$store.state.dangerLevels || [])
      const hit = list.find(item => String(item.id) === String(levelId))
      return hit ? hit.level : ''
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    // 打开当前危险源的风险点管理弹窗
    handleRiskManage(row) {
      this.hazardId = row.id;
      this.hazardName = row.name;
      // 打开时重置数据(不在关闭时改表格数据,避免弹窗关闭过程中表格重渲染)
      this.riskTableData = [];
      this.riskTotal = 0;
      this.riskFormVisible = false;
      this.riskDelVisible = false;
      this.riskVisible = true;
      this.$nextTick(() => {
        if (this.$refs.riskPage) this.$refs.riskPage.page = 1;
        this.getRiskList();
      });
    },
    // 风险点表单重置(不用 resetFields,避免受首次渲染初值影响)
    handleRiskReset() {
      this.riskRuleForm.name = '';
      this.riskRuleForm.description = '';
      if (this.$refs.riskRuleForm) this.$refs.riskRuleForm.clearValidate();
    },
    // 风险点列表:api/hazards/risk/list?hazard_id=xxx
    async getRiskList() {
      if (!this.hazardId) return;
      let pageChild = this.$refs.riskPage;
      let params = {
        hazard_id: this.hazardId,
        page: pageChild ? pageChild.page : 1,
        size: pageChild ? pageChild.size : 10,
      };
      let res = await this.$api.instance.interfaceServer('api/hazards/risk/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.riskTableData = res.data.data || [];
        this.riskTotal = res.data.total || 0;
      }
    },
    handleRiskAdd() {
      this.riskType = 'add';
      this.riskTitle = '新增';
      this.riskRuleForm = { hazard_id: this.hazardId, name: '', description: '' };
      this.riskFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.riskRuleForm) this.$refs.riskRuleForm.clearValidate();
      });
    },
    handleRiskEdit(row) {
      this.riskType = 'edit';
      this.riskTitle = '编辑';
      this.riskRuleForm = {
        id: row.id,
        hazard_id: this.hazardId,
        name: row.name,
        description: row.description,
      };
      this.riskFormVisible = true;
    },
    // 新增风险点:api/hazards/risk/create
    async createRiskMethod() {
      let params = this.$until.deleteNullPrototype(this.riskRuleForm);
      let res = await this.$api.instance.interfaceServer('api/hazards/risk/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.riskFormVisible = false;
        this.getRiskList();
      }
    },
    // 编辑风险点:api/hazards/risk/save/{id}
    async updateRiskMethod() {
      let params = this.$until.easyDeepCopy(this.riskRuleForm);
      let res = await this.$api.instance.interfaceServer(`api/hazards/risk/save/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.riskFormVisible = false;
        this.getRiskList();
      }
    },
    handleRiskDelet(id) {
      this.riskDelId = id;
      this.riskDelVisible = true;
    },
    // 删除风险点:api/hazards/risk/delete/{id}
    async deleteRiskMethod() {
      let res = await this.$api.instance.interfaceServer(`api/hazards/risk/delete/${this.riskDelId}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.riskDelVisible = false;
        this.backPage('riskPage', this.riskTableData);
        this.getRiskList();
      }
    },
    // 打开当前风险点的维护措施弹窗
    handleMeasuresManage(row) {
      this.riskId = row.id;
      this.riskName = row.name;
      // 打开时重置数据(不在关闭时改表格数据,避免弹窗关闭过程中表格重渲染)
      this.measuresTableData = [];
      this.measuresTotal = 0;
      this.measuresFormVisible = false;
      this.measuresDelVisible = false;
      this.measuresVisible = true;
      this.$nextTick(() => {
        if (this.$refs.measuresPage) this.$refs.measuresPage.page = 1;
        this.getMeasuresList();
      });
    },
    // 措施表单重置(不用 resetFields,避免受首次渲染初值影响)
    handleMeasuresReset() {
      this.measuresRuleForm.content = '';
      this.measuresRuleForm.order = 10;
      if (this.$refs.measuresRuleForm) this.$refs.measuresRuleForm.clearValidate();
    },
    // 维护措施列表:api/hazards/measures/list?risk_id=xxx
    async getMeasuresList() {
      if (!this.riskId) return;
      let pageChild = this.$refs.measuresPage;
      let params = {
        risk_id: this.riskId,
        page: pageChild ? pageChild.page : 1,
        size: pageChild ? pageChild.size : 10,
      };
      let res = await this.$api.instance.interfaceServer('api/hazards/measures/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.measuresTableData = res.data.data || [];
        this.measuresTotal = res.data.total || 0;
      }
    },
    handleMeasuresAdd() {
      this.measuresType = 'add';
      this.measuresTitle = '新增';
      this.measuresRuleForm = { risk_id: this.riskId, content: '', order: 10 };
      this.measuresFormVisible = true;
      this.$nextTick(() => {
        if (this.$refs.measuresRuleForm) this.$refs.measuresRuleForm.clearValidate();
      });
    },
    handleMeasuresEdit(row) {
      this.measuresType = 'edit';
      this.measuresTitle = '编辑';
      this.measuresRuleForm = {
        id: row.id,
        risk_id: this.riskId,
        content: row.content,
        order: row.order,
      };
      this.measuresFormVisible = true;
    },
    // 新增维护措施:api/hazards/measures/create
    async createMeasuresMethod() {
      let params = this.$until.deleteNullPrototype(this.measuresRuleForm);
      let res = await this.$api.instance.interfaceServer('api/hazards/measures/create', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.measuresFormVisible = false;
        this.getMeasuresList();
      }
    },
    // 编辑维护措施:api/hazards/measures/save/{id}
    async updateMeasuresMethod() {
      let params = this.$until.easyDeepCopy(this.measuresRuleForm);
      let res = await this.$api.instance.interfaceServer(`api/hazards/measures/save/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.measuresFormVisible = false;
        this.getMeasuresList();
      }
    },
    handleMeasuresDelet(id) {
      this.measuresDelId = id;
      this.measuresDelVisible = true;
    },
    // 删除维护措施:api/hazards/measures/delete/{id}
    async deleteMeasuresMethod() {
      let res = await this.$api.instance.interfaceServer(`api/hazards/measures/delete/${this.measuresDelId}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.measuresDelVisible = false;
        this.backPage('measuresPage', this.measuresTableData);
        this.getMeasuresList();
      }
    },
    // 删除后当前页只剩最后一条时回退一页
    backPage(refName, list) {
      if (list.length == 1 && this.$refs[refName] && this.$refs[refName].page > 1) {
        this.$refs[refName].page -= 1;
      }
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/hazards/delete/${params.id}`, 'delete', {});
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    // 新增:api/hazards/store,字段仅 name / level / level_id
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      if (!params.level && params.level_id) params.level = this.getLevelName(params.level_id)
      let res = await this.$api.instance.interfaceServer('api/hazards/store', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // 编辑:api/hazards/update/{id},字段仅 name / level / level_id
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);
      if (!params.level && params.level_id) params.level = this.getLevelName(params.level_id)
      let res = await this.$api.instance.interfaceServer(`api/hazards/update/${params.id}`, 'put', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    handleQuery() {
      // this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/hazards/list', 'get', params);
      if (res.code == 0 && res.data) {
        // console.log( this.treeArr)
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },


  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
